import React from 'react';
import Lottie from "lottie-react";
import game from "../LoadingSvg/game.json";

const Game = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // height: "80svh",
            }}
        >
            <Lottie
                animationData={game}
                loop={true}
                style={{ width: "300px", height: "300px" }}
                className='svges'
            />
        </div>
    )
}

export default Game